import { GetPrivacyPolicy, UpdatePrivacyPolicy, CreatePrivacyPolicy } from "../../../connection/privacy-policy";
import { Action, AsyncAction } from "../../../types/actions";
import { PrivacyPolicy, CreatePrivacyPolicyRequest } from "../../../types/working-model";

export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export function getPrivacyPolicy(policy: number): AsyncAction {
	return {
		type: GET_PRIVACY_POLICY,
		promise: GetPrivacyPolicy(policy),
	};
}

export const CREATE_PRIVACY_POLICY = 'CREATE_PRIVACY_POLICY';
export function createPrivacyPolicy(newPolicy: CreatePrivacyPolicyRequest, token: string): AsyncAction {
	return {
		type: CREATE_PRIVACY_POLICY,
		promise: CreatePrivacyPolicy(newPolicy, token),
	};
}

export const UPDATE_PRIVACY_POLICY = 'UPDATE_PRIVACY_POLICY';
export function updatePrivacyPolicy(policy: PrivacyPolicy, token: string): AsyncAction {
	return {
		type: UPDATE_PRIVACY_POLICY,
		promise: UpdatePrivacyPolicy(policy, token),
	};
}

export const CLEAR_PRIVACY_POLICY = 'CLEAR_PRIVACY_POLICY';
export function clearPrivacyPolicy(): Action {
	return {
		type: CLEAR_PRIVACY_POLICY,
		payload: null,
	};
}
